import TransactionOccurrenceDetails from "../../../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";
import ScheduleTxnOccurrencesPopup from "../../../../ScheduleTransactions/ScheduleTxnOccurrencesPopup";

const ScheduleInternalTransactionStepFrequency = ({
  txnPayLoad,
  setTxnPayLoad,
  openOccurrencesModal,
  setOpenOccurrencesModal,
  scheduleOccurrenceDates,
  availableSlots,
  frequencyOptions,
  frequencyStartDate,
  frequencyEndDate,
  setFrequencyStartDate,
  setFrequencyEndDate,
  showDatePicker,
  setShowDatePicker,
  showEndDatePicker,
  setShowEndDatePicker,
  dropdownOpen,
  setDropdownOpen,
  slotDropdownOpen,
  setSlotDropdownOpen,
  yearDropdownRef,
  formatDate,
  handleStartDateConfirm,
  handleStartDateCancel,
  handleEndDateConfirm,
  handleEndDateCancel,
  getEndDate,
  weekdays,
  months,
}) => {
  return (
    <div className="w-width-full px-padding-md lg:px-padding-base py-padding-md lg:mb-margin-base mb-margin-xxl overflow-y">
      {openOccurrencesModal && (
        <div className="z-z-index-max fixed">
          <ScheduleTxnOccurrencesPopup
            closeCallback={() => setOpenOccurrencesModal(false)}
            occurrences={scheduleOccurrenceDates}
          />
        </div>
      )}

      <TransactionOccurrenceDetails
        txnPayLoad={txnPayLoad}
        setTxnPayLoad={setTxnPayLoad}
        SlotMappingData={availableSlots}
        frequencyOptions={frequencyOptions}
        startDate={frequencyStartDate}
        endDate={frequencyEndDate}
        setStartDate={setFrequencyStartDate}
        setEndDate={setFrequencyEndDate}
        showDatePicker={showDatePicker}
        setShowDatePicker={setShowDatePicker}
        showEndDatePicker={showEndDatePicker}
        setShowEndDatePicker={setShowEndDatePicker}
        dropdownOpen={dropdownOpen}
        setDropdownOpen={setDropdownOpen}
        slotdropdownOpen={slotDropdownOpen}
        setSlotDropdownOpen={setSlotDropdownOpen}
        yearDropdownRef={yearDropdownRef}
        formatDate={formatDate}
        handleDateChange={setFrequencyStartDate}
        handleEndDateChange={setFrequencyEndDate}
        handleConfirm={handleStartDateConfirm}
        handleCancel={handleStartDateCancel}
        handleEndConfirm={handleEndDateConfirm}
        handleEndCancel={handleEndDateCancel}
        getEndDate={getEndDate}
        weekdays={weekdays}
        months={months}
        setOpenOccurrencesModal={setOpenOccurrencesModal}
      />

      <div className="h-mobile-create-header w-width-full Qmd:hidden block mb-margin-xl lg:mb-margin-base"></div>
    </div>
  );
};

export default ScheduleInternalTransactionStepFrequency;
